import { jsonApi } from '@models/jsonApi';

jsonApi.define('billing/billing-weight', {
  feature_id: 0,
  weight_day: 0,
  weight: 0,
  created_at: '',
  updated_at: '',
});
